var _rect, _circle, _rect2, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _path, _path2, _path3, _line14, _line15, _line16, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatherTimeResult3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 360,
    viewBox: "0 0 422 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206.696,
    y: 111.925,
    width: 14.0046,
    height: 6.39726,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213.699,
    cy: 205.74,
    r: 85.2603,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 194.614,
    y: 98.5,
    width: 38.1689,
    height: 11.3196,
    rx: 5.65982,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.699,
    cy: 205.74,
    r: 78.9954,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 215.699,
    y1: 132.352,
    x2: 215.699,
    y2: 146.224,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 178.936,
    y1: 141.368,
    x2: 185.872,
    y2: 153.382,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 149.155,
    y1: 240.702,
    x2: 161.169,
    y2: 233.766,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 175.273,
    y1: 268.308,
    x2: 182.209,
    y2: 256.295,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 151.155,
    y1: 167.314,
    x2: 163.169,
    y2: 174.25,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 140.311,
    y1: 203.74,
    x2: 154.183,
    y2: 203.74,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 215.699,
    y1: 265.256,
    x2: 215.699,
    y2: 279.128,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 245.389,
    y1: 256.466,
    x2: 252.325,
    y2: 268.48,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 264.254,
    y1: 174.25,
    x2: 276.267,
    y2: 167.314,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 241.724,
    y1: 153.21,
    x2: 248.661,
    y2: 141.196,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 266.254,
    y1: 233.766,
    x2: 278.267,
    y2: 240.702,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 273.215,
    y1: 203.74,
    x2: 287.087,
    y2: 203.74,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 251.353,
    y1: 281.697,
    x2: 268.353,
    y2: 311.142,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.88 321.08V324.296H281.896L284.68 325.904V333.512L281.896 335.12H275.824L273.04 333.512V330.08H276.4V332.24H281.32V327.176H273.52V318.2H284.44V321.08H276.88ZM299.505 323.8L303.505 335H301.297L300.449 332.584H296.257L295.409 335H293.201L297.201 323.8H299.505ZM298.337 326.616L296.929 330.664H299.761L298.369 326.616H298.337ZM314.526 335V327.608H314.494L311.966 335H309.838L307.294 327.512H307.262V335H305.102V323.8H308.078L310.894 332.04H310.926L313.726 323.8H316.686V335H314.526ZM318.439 335.32L322.215 323.48H324.295L320.519 335.32H318.439ZM326.055 335V323.8H331.959L333.815 324.872V329.864L331.959 330.936H328.295V335H326.055ZM328.295 325.72V329.016H331.575V325.72H328.295ZM345.479 335V327.608H345.447L342.919 335H340.791L338.247 327.512H338.215V335H336.055V323.8H339.031L341.847 332.04H341.879L344.679 323.8H347.639V335H345.479Z",
    fill: "#FFF761"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4039 270.24H27.3239V265.752H22.4039V270.24ZM22.4039 262.872H27.3239V258.96H22.4039V262.872ZM27.8999 273.12H21.4439L19.0439 271.512V265.536L21.1319 264.336V264.288L19.0439 263.088V257.688L21.8279 256.08H27.8999L30.6839 257.688V263.088L28.5959 264.288V264.336L30.6839 265.536V271.512L27.8999 273.12ZM45.5088 261.8L49.5088 273H47.3008L46.4528 270.584H42.2608L41.4128 273H39.2048L43.2048 261.8H45.5088ZM44.3408 264.616L42.9328 268.664H45.7648L44.3728 264.616H44.3408ZM60.5301 273V265.608H60.4981L57.9701 273H55.8421L53.2981 265.512H53.2661V273H51.1061V261.8H54.0821L56.8981 270.04H56.9301L59.7301 261.8H62.6901V273H60.5301ZM64.443 273.32L68.219 261.48H70.299L66.523 273.32H64.443ZM72.0592 273V261.8H77.9632L79.8192 262.872V267.864L77.9632 268.936H74.2992V273H72.0592ZM74.2992 263.72V267.016H77.5792V263.72H74.2992ZM91.4832 273V265.608H91.4512L88.9232 273H86.7952L84.2512 265.512H84.2192V273H82.0592V261.8H85.0352L87.8512 270.04H87.8832L90.6832 261.8H93.6432V273H91.4832Z",
    fill: "#FFF761"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4853 76.816V73.672L56.8053 71.2H59.6853V85.12H63.5253V88H52.4853V85.12H56.3253V74.608L52.4853 76.816ZM66.4072 76.816V73.672L70.7272 71.2H73.6072V85.12H77.4472V88H66.4072V85.12H70.2472V74.608L66.4072 76.816ZM91.0674 76.8L95.0674 88H92.8594L92.0114 85.584H87.8194L86.9714 88H84.7634L88.7634 76.8H91.0674ZM89.8994 79.616L88.4914 83.664H91.3234L89.9314 79.616H89.8994ZM106.089 88V80.608H106.057L103.529 88H101.401L98.8567 80.512H98.8247V88H96.6647V76.8H99.6407L102.457 85.04H102.489L105.289 76.8H108.249V88H106.089ZM110.002 88.32L113.778 76.48H115.858L112.082 88.32H110.002ZM117.618 88V76.8H123.522L125.378 77.872V82.864L123.522 83.936H119.858V88H117.618ZM119.858 78.72V82.016H123.138V78.72H119.858ZM137.042 88V80.608H137.01L134.482 88H132.354L129.81 80.512H129.778V88H127.618V76.8H130.594L133.41 85.04H133.442L136.242 76.8H139.202V88H137.042Z",
    fill: "#FFF761"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 286.878,
    y1: 162.817,
    x2: 315.457,
    y2: 146.317,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 137.15,
    y1: 248.905,
    x2: 106.497,
    y2: 266.436,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 163.853,
    y1: 130.143,
    x2: 143.853,
    y2: 95.5016,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M326.591 147.12H334.511V150H323.231V142.104L326.015 140.496H331.151V136.08H326.591V138.24H323.231V134.808L326.015 133.2H331.727L334.511 134.808V141.768L331.727 143.376H326.591V147.12ZM349.321 138.8L353.321 150H351.113L350.265 147.584H346.073L345.225 150H343.017L347.017 138.8H349.321ZM348.153 141.616L346.745 145.664H349.577L348.185 141.616H348.153ZM364.343 150V142.608H364.311L361.783 150H359.655L357.111 142.512H357.079V150H354.919V138.8H357.895L360.711 147.04H360.743L363.543 138.8H366.503V150H364.343ZM368.255 150.32L372.031 138.48H374.111L370.335 150.32H368.255ZM375.872 150V138.8H381.776L383.632 139.872V144.864L381.776 145.936H378.112V150H375.872ZM378.112 140.72V144.016H381.392V140.72H378.112ZM395.296 150V142.608H395.264L392.736 150H390.608L388.064 142.512H388.032V150H385.872V138.8H388.848L391.664 147.04H391.696L394.496 138.8H397.456V150H395.296Z",
    fill: "#FFF761"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatherTimeResult3);
export default __webpack_public_path__ + "static/media/gatherTimeResult3.179595f3509b8df94a7969dcabf52996.svg";
export { ForwardRef as ReactComponent };